var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.462 18.4908V15.5708C5.462 14.6008 6.222 13.7308 7.302 13.7308C8.272 13.7308 9.142 14.4908 9.142 15.5708V18.3808C9.142 20.3308 7.522 21.9508 5.572 21.9508C3.622 21.9508 2.002 20.3208 2.002 18.3808V12.2208C1.892 6.60078 6.332 2.05078 11.952 2.05078C17.572 2.05078 22.002 6.60078 22.002 12.1108V18.2708C22.002 20.2208 20.382 21.8408 18.432 21.8408C16.482 21.8408 14.862 20.2208 14.862 18.2708V15.4608C14.862 14.4908 15.622 13.6208 16.702 13.6208C17.672 13.6208 18.542 14.3808 18.542 15.4608V18.4908",
    stroke: "#7B7B8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.f5f98576abf1c04ef982e19325cfd356.svg";
export { ForwardRef as ReactComponent };